<template>
	<div class="inline relative whitespace-nowrap">
		<span class="opacity-0 whitespace-nowrap">{{ props.texts[0] }}</span>
		<span class="absolute left-0 h-[1lh] whitespace-nowrap">
			<transition
				enter-active-class="transition ease-in-out duration-700"
				leave-active-class="transition ease-in-out duration-700"
				enter-from-class="opacity-0 translate-y-full"
				enter-to-class="opacity-100 translate-y-0"
				leave-from-class="opacity-100 translate-y-0"
				leave-to-class="opacity-0 -translate-y-full"
			>
				<span v-if="currentText" :key="currentText" class="absolute inline-block whitespace-nowrap">
					{{ currentText }}
				</span>
			</transition>
		</span>
	</div>
</template>

<script setup>
	import { ref, onMounted } from 'vue';

	const props = defineProps({
		texts: {
			type: Array,
			required: true
		}
	});

	const currentIndex = ref(0);
	const currentText = ref(props.texts[currentIndex.value]);

	const updateText = () => {
		currentIndex.value = (currentIndex.value + 1) % props.texts.length;
		currentText.value = props.texts[currentIndex.value];
	};

	onMounted(() => {
		setInterval(updateText, 3000); // Change every 3 seconds
	});
</script>